export default "__VITE_ASSET__DK8_1$ij__"